import {
  Button,
  Card,
  Col,
  Descriptions,
  Divider,
  message,
  Modal,
  Progress,
  Row,
  Space,
  Spin,
  Tag,
} from 'antd';
import {LockOutlined, UnlockOutlined, ExclamationCircleFilled} from '@ant-design/icons';
import DescriptionsItem from 'antd/lib/descriptions/Item';
import {useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from '../../common/hooks';
import {
  customerData,
  rackScreenData,
  billing,
  swapInitialize,
  acceptSlotOpen,
  batterySubmitted,
  provisionSlotOpen,
  batteryRemoved,
  billingCompleted,
  clearSwapState,
  terminating,
  warning,
  submitBattery,
} from './rackScreenSlice';
import Page500 from '../Page500';
import InfoModal from '../common/batteryDetailModal';
import {battteryDetails} from '../liveBatteries/liveBatteriesSlice';
import SwapModal from './swapModal';
import {mqttType} from '../../common/constants';
import useMQTT from '../../common/useMqtt';
import AssignBatteryModal from './AssignBatteryModal';
import {authStationsList} from '../setup/station/stations/stationsSlice';
import {racksList} from '../setup/rack/racks/racksSlice';
const {confirm} = Modal;

const RackScreen = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [isSwapModalOpen, setIsSwapModalOpen] = useState(false);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);

  const [station, setStation] = useState<number>(0);
  const [rack, setRack] = useState<number>(0);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const orgId = useAppSelector((state) => state.auth.user.details.organisationId);
  const handleSwapModalClose = () => {
    setIsSwapModalOpen(false);
    dispatch(clearSwapState());
    dispatch(rackScreenData({station_id: station, rack_id: rack}));
  };

  const dispatch = useAppDispatch();
  const state = useAppSelector((state) => state.rackScreen);

  const handleMqttData = (data: any) => {
    if (data.type === mqttType.DATA_UPDATE) {
      console.log(data);
      setTimeout(() => {
        dispatch(rackScreenData({station_id: station, rack_id: rack}));
      }, 2000);
    }
    if (data.type === mqttType.ACCEPT_SLOT_OPEN) {
      console.log(data);
      dispatch(acceptSlotOpen(data.rack_position));
    }
    if (data.type === mqttType.USER_DATA) {
      dispatch(
        customerData({name: data.user_data.username, batteries: data.user_data.user_batteries}),
      );
    }
    if (data.type === mqttType.BATTERY_SUBMITTED) {
      dispatch(batterySubmitted(data.batteries_submitted));
      console.log(data);
    }
    if (data.type === mqttType.PROVISION_SLOT_OPEN) {
      console.log(data);
      dispatch(provisionSlotOpen(data.rack_position));
    }
    if (data.type === mqttType.BATTERY_REMOVED) {
      console.log(data);
      dispatch(batteryRemoved(data.batteries_removed));
    }
    if (data.type === mqttType.BILLING) {
      console.log(data);
      dispatch(billing(data.billing_details));
    }
    if (data.type === mqttType.BILLING_COMPLETE) {
      console.log(data);
      dispatch(billingCompleted());
    }
    if (data.type === mqttType.TERMINATING) {
      console.log(data);
      dispatch(terminating(data.message));
    }
    if (data.type === mqttType.WARNING) {
      console.log(data);
      dispatch(warning(data.warning));
    }
  };
  const [mqttMessage] = useMQTT(`${isLoaded ? `swap/${orgId}/${state.data.rack_id}/bpub` : ''}`);

  useEffect(() => {
    if (mqttMessage !== undefined) {
      handleMqttData(mqttMessage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mqttMessage]);

  useEffect(() => {
    dispatch(authStationsList({is_active: true}))
      .unwrap()
      .then((station) => {
        setStation(station.data.pageData[0].id);
        dispatch(racksList({station_id: [station.data.pageData[0].id]}))
          .unwrap()
          .then((rack) => {
            setRack(rack.data.pageData[0].id);
            dispatch(
              rackScreenData({
                station_id: station.data.pageData[0].id,
                rack_id: rack.data.pageData[0].id,
              }),
            )
              .then(() => {
                setIsLoaded(true);
              })
              .catch(() => {
                setIsError(true);
              });
          });
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isLoaded ? (
    isError ? (
      <Page500 />
    ) : (
      state.data && (
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexFlow: 'wrap',
            justifyContent: 'space-evenly',
            paddingBottom: '80px',
          }}
        >
          {state.data.charger_info.map((card, i) => {
            return (
              <Card
                key={i}
                bordered={false}
                style={{
                  width: '300px',
                  boxShadow: '10px 10px 10px 2px rgba(0, 0, 0, 0.2)',
                  backgroundColor: '#93c6cb3d',
                  borderRadius: '10px',
                  cursor: card.bid !== '00000000' ? 'pointer' : 'default',
                  margin: '20px',
                  minWidth: '300px',
                }}
                onClick={() => {
                  card.bid !== '00000000'
                    ? dispatch(battteryDetails({asset_id: card.bid}))
                        .unwrap()
                        .then(() => {
                          setIsInfoModalOpen(true);
                        })
                    : message.warning('EMPTY SLOT');
                }}
              >
                <div>
                  <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <h3 style={{margin: '0px'}}>{card.name}</h3>
                    <Space>
                      <p
                        style={{
                          margin: '0px 10px ',
                          paddingInline: '5px',
                          backgroundColor: 'transparent',
                          border: '1px solid #00000040',
                          borderRadius: '5px',
                          fontWeight: 'bold',
                        }}
                      >
                        {card.rack_position + 1}
                      </p>
                      {card.lock ? (
                        <LockOutlined
                          style={{scale: '1.5', padding: '5px 5px 0px 0px', color: '#1890ff'}}
                        />
                      ) : (
                        <UnlockOutlined
                          style={{scale: '1.5', padding: '5px 5px 0px 0px', color: 'red'}}
                        />
                      )}
                    </Space>
                  </div>
                  <Divider
                    style={{
                      margin: '5px 0px 5px 0px',
                      width: '100%',
                      backgroundColor: '#00000040',
                    }}
                  />
                  <Row>
                    <Col span={7} offset={1}>
                      <div style={{width: '50px', paddingBlock: '25%'}}>
                        <Progress
                          type='circle'
                          percent={card.soc}
                          width={50}
                          format={(percent) => ` ${percent}%`}
                          //status={state.soc < 20 ? 'exception' : state.soc > 70 ? 'success' : 'normal'}
                        />
                        <h3 style={{textAlign: 'center'}}>Charge</h3>
                      </div>
                      <div style={{width: '50px'}}>
                        <Progress
                          type='circle'
                          percent={card.soh}
                          width={50}
                          //status={state.soh < 30 ? 'exception' : 'normal'}
                          format={(percent) => `${percent}%`}
                        />
                        <h3 style={{textAlign: 'center'}}>Health</h3>
                      </div>
                      {/* </Space> */}
                    </Col>
                    <Col span={14} offset={2}>
                      <Descriptions
                        column={1}
                        bordered
                        labelStyle={{
                          backgroundColor: 'transparent',
                          fontWeight: 'bolder',
                          padding: '5px 7px',
                        }}
                        contentStyle={{fontSize: '16px', padding: '5px 7px'}}
                      >
                        <DescriptionsItem label='Charging'>
                          {card.current > 200 ? (
                            <Tag color='success'>ON</Tag>
                          ) : (
                            <Tag color='red'>OFF</Tag>
                          )}
                        </DescriptionsItem>
                        <DescriptionsItem label='Current'>
                          {card.current > 200 || card.current < -200
                            ? card.current / 1000 + ' A'
                            : '0 A'}
                        </DescriptionsItem>
                        <DescriptionsItem label='Voltage'>
                          {card.pack_voltage ? card.pack_voltage / 1000 + ' V' : '0 V'}
                        </DescriptionsItem>
                        <DescriptionsItem label='Temp.'>
                          {card.temp_average ? card.temp_average.toFixed(2) : 0} &deg;C
                        </DescriptionsItem>
                        <DescriptionsItem label='Fault '>
                          {card.fault_status ? (
                            card.fault_status.length === 0 ? (
                              <Tag color='success'>All Ok</Tag>
                            ) : (
                              <Tag color='red'>Fault</Tag>
                            )
                          ) : (
                            <Tag color='success'>All Ok</Tag>
                          )}
                        </DescriptionsItem>
                        <DescriptionsItem label='Fan '>
                          {
                            <img
                              src='fan.svg'
                              alt='fan'
                              className={card.cooling ? 'fan-icon-animation' : 'fan-icon'}
                            />
                          }
                        </DescriptionsItem>
                      </Descriptions>
                    </Col>
                  </Row>
                </div>
              </Card>
            );
          })}
          <div
            style={{
              backgroundColor: '#fff',
              display: 'flex',
              width: '100%',
              height: '80px',
              position: 'fixed',
              bottom: '0px',
              justifyContent: 'center',
              padding: '10px',
              borderTop: '1px solid #000000',
            }}
          >
            <Button
              type='primary'
              size='large'
              style={{
                fontWeight: 'bold',
                marginInline: '10px',
                height: '50px',
                borderRadius: '8px',
              }}
              onClick={() => {
                const chargedBatteires = state.data.charger_info.filter(
                  (x) => x.soc > state.data.min_soc,
                ).length;
                if (chargedBatteires == 1) {
                  confirm({
                    title: ' Only 1 battey is available, Do you want to continue',
                    icon: <ExclamationCircleFilled />,
                    okText: 'Yes',
                    okType: 'primary',
                    cancelText: 'No',
                    onOk() {
                      dispatch(swapInitialize({rack_id: state.data.rack_id}))
                        .unwrap()
                        .then(() => {
                          setIsSwapModalOpen(true);
                        });
                    },
                  });
                } else if (chargedBatteires < 1) {
                  Modal.error({
                    title: 'Charged batteries are not available.',
                  });
                } else {
                  dispatch(swapInitialize({rack_id: state.data.rack_id}))
                    .unwrap()
                    .then(() => {
                      setIsSwapModalOpen(true);
                    });
                }
              }}
            >
              Start Swap
            </Button>
            <Button
              type='primary'
              size='large'
              style={{
                fontWeight: 'bold',
                marginInline: '10px',
                height: '50px',
                borderRadius: '8px',
              }}
              onClick={() => {
                dispatch(clearSwapState());
                dispatch(submitBattery({station_id: station, rack_id: rack})).then(() =>
                  setIsSwapModalOpen(true),
                );
              }}
            >
              Submit Battery
            </Button>
            <Button
              type='primary'
              size='large'
              style={{
                fontWeight: 'bold',
                marginInline: '10px',
                height: '50px',
                borderRadius: '8px',
              }}
              onClick={() => {
                setIsAssignModalOpen(true);
              }}
            >
              Assign Batttery
            </Button>
          </div>
          {isInfoModalOpen && <InfoModal isOpen={isInfoModalOpen} setIsOpen={setIsInfoModalOpen} />}
          {isSwapModalOpen && (
            <SwapModal isOpen={isSwapModalOpen} setIsOpen={handleSwapModalClose} />
          )}

          {isAssignModalOpen && (
            <AssignBatteryModal
              isOpen={isAssignModalOpen}
              setIsOpen={setIsAssignModalOpen}
              rack_id={state.data.rack_id}
              station_id={state.data.station_id}
              swapModal={setIsSwapModalOpen}
            />
          )}
        </div>
      )
    )
  ) : (
    <Spin spinning={isLoaded} />
  );
};

export default RackScreen;
